<template>
  <footer class="footer" ref="footerH">
    <div v-if="brandKey === 'rwc'" class="branded-footer">
      <div class="branded-footercontent">
        <div class="bf-left">
          <img src="~@/assets/images/brands/rwc/RWC_Logo_Casino-Resort-RGB-KO.png">
          <div class="line"></div>
          <div class="text" v-html="$t('Footer.playResponsiblyDesc')"></div>
        </div>
        <div class="bf-right">
          <img src="~@/assets/images/brands/rwc/Playtime-Elevated-Building.png">
          <div class="contact-us">
            <router-link :to="{ name: 'info', params: { infopagename : 'contact' }}">{{ $t('Footer.ContactUs') }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <template>  
      <div class="footer-top footercontent">
        <div class="footer-top-left">
          <section class="company-pr">
            <div class="link">
              <img src="/static/images/footer/gamble-banner.png">
              <router-link :to="{ name: 'info', params: { infopagename : 'responsible-gaming' }}">{{ $t('Footer.FindOutMore') }}</router-link>
            </div>
          </section>
        </div>
      </div>
      <section class="footer-ocean-state">
        <section class="footercontent">
          <div class="col-right">{{ $t('Footer.oceanState') }}</div>
        </section>
      </section>
      <section class="bottom-info">
        <section class="footer-menu">
          <site-navigation :navigation-section="'FOOTER_MENU_RWC'"></site-navigation>
        </section>
      </section>
      <section class="footer-bottom">
        <div class="text">{{ $t('Footer.info.companyName') }}</div>
        <section class="back-to-top" :class="{'ios-back-to-top' :  userAgent === 'ios' && appVersion === 'safari'}"><a @click="goBack()"><v-icon>expand_less</v-icon></a></section>
    </section>
    </template>
  </footer>
</template>

<script>
  import lib from '@/library'
  import config from '@/config'
  import SiteNavigation from '@/components/common/SiteNavigation'
  import Branding from '@/components/mixins/Branding'
  import store from '@/store'

  export default {
    name: 'FooterPart',

    components: {
      SiteNavigation
    },
    mixins: [
      Branding
    ],

    data () {
      return {
      }
    },

    computed: {
      config () { return config },
      state () { return config.app.autoconf.STATE },
      dateFormats () { return config.app.dateFormats },
      userAgentName () {
        return lib.core.userAgent.browser.name
      },
      userAgent () {
        return lib.core.userAgent.os.name
      },
      appVersion () {
        if (navigator.appVersion.indexOf('Safari') !== -1) {
          return 'safari'
        } else {
          return undefined
        }
      }
    },

    methods: {
      footerHeight () {
        if (this.$refs.footerH) {
          store.commit('screenState/setFooterHeight', this.$refs.footerH.clientHeight)
        }
      },
      goBack () {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }, 200)
      }
    },
    created () {

    },
    mounted () {
      setTimeout(() => {
        this.footerHeight()
      }, 1000)
    },
    updated () {
      this.footerHeight()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.browser-internet-explorer 
  .footer-top-left
    display block


</style>





// WEBPACK FOOTER //
// src/components/layout/parts/FooterPart.vue